import React from "react";
import CoreComponent from "../core_component";
import {withTranslation} from "react-i18next";
import {Col, FormGroup} from "reactstrap";
import LabelWithError from "../helper/label_with_error";
import {DateRangePick} from "../helper/date_range_picker";
import FormGroupWErr from "../helper/form_group_w_err";
import FiltersContainer from "../helper/filters_container";
import FormGroupCheckbox from "../helper/form_group_checkbox";

class WebApiTransactionFilters extends CoreComponent {

  renderFilters = (filtersData, onChange) => {
    return (
      <>
        <Col md={3}>
          <FormGroup>
            <LabelWithError>
              {this.trans("date")}
            </LabelWithError>
            <DateRangePick
              name={"dateRange"}
              onChange={onChange}
              value={filtersData.dateRange}
            />
          </FormGroup>
        </Col>
        <Col md={2}>
          <FormGroupWErr
            str={"webApiName"} val={filtersData.webApiName}
            onChange={onChange} required={false}
          />
        </Col>
        <Col md={2}>
          <FormGroupWErr
            str={"cardPan"} label={"pan"} val={filtersData.cardPan}
            onChange={onChange} required={false}
          />
        </Col>
        <Col md={2}>
          <FormGroupCheckbox
            str={"excludeCancelledTransactions"} val={filtersData.excludeCancelledTransactions || false}
            onChange={onChange} required={false} vertical={true}
          />
        </Col>
      </>
    );
  };

  render() {
    return (
      <FiltersContainer
        renderFilters={this.renderFilters}
        onFilter={this.props.onFilter}
        extraButtons={this.props.extraButtons}
        initData={this.props.initialPageFilters}
      />
    );
  }

}

export default withTranslation()(WebApiTransactionFilters);
